module.exports = __webpack_public_path__ + "img/0861-circle-minus.9391d834.svg";